import { rest } from "msw";
import type { RestHandler } from "msw";
import config from "../../../config";
import { createUrl } from "../../protect-api";
import { apiVersion } from "../../../shared/constants/common.constant";
import type {
  SanctionBody,
  SettingsValues,
} from "../../../shared/types/common.type";
import type {
  PreferencesResponse,
  UpdatePreferencesPayload,
} from "../../../modules/global-settings/settings.types";

const HTTP_OK = 200;
const HTTPS_ERROR = 404;

export const mockGetSanctionBodies: RestHandler = rest.get(
  createUrl(`${config.COMPLIANCE_API_URL}/${apiVersion}/lookup/sanctionBodies`),
  async (_, res, ctx) => {
    const sanctionBodies: SanctionBody[] = [
      {
        id: 1,
        name: "Asian Development Bank",
        region: "eas",
      },
      {
        id: 2,
        name: "Australian Department of Foreign Affairs and Trade",
        region: "eas",
      },
      {
        id: 3,
        name: "Australian Government National Security",
        region: "eas",
      },
      {
        id: 4,
        name: "Australian National Security",
        region: "eas",
      },
      {
        id: 5,
        name: "Azerbaijan Financial Markets Supervision Chamber - Financial Monitoring Service",
        region: "ecs",
      },
      {
        id: 6,
        name: "Bahrain Ministry of Foreign Affairs",
        region: "mea",
      },
      {
        id: 7,
        name: "Belgian Federal Public Service Finance",
        region: "ecs",
      },
      {
        id: 8,
        name: "Canadian Government Sanctions",
        region: "nac",
      },
      {
        id: 9,
        name: "Central Bank of Bangladesh",
        region: "sas",
      },
      {
        id: 10,
        name: "Central Bank of Egypt",
        region: "mea",
      },
    ];

    return res(ctx.status(HTTP_OK), ctx.json(sanctionBodies));
  }
);

export const mockGetPreferences = (
  preferencesMap: Record<string, PreferencesResponse>
): RestHandler =>
  rest.get(
    createUrl(
      `${config.COMPLIANCE_API_URL}/${apiVersion}/settings/preferences/aml`
    ),
    async (req, res, ctx) => {
      const searchType = req.url.searchParams.get("searchType");
      const searchActionType = req.url.searchParams.get("searchActionType");

      const key = `${searchType}_${searchActionType}`;
      const response = preferencesMap[key];

      if (!response) {
        return res(ctx.status(HTTPS_ERROR), ctx.json({ message: "Not found" }));
      }

      return res(ctx.status(HTTP_OK), ctx.json(response));
    }
  );

export const mockPutPreferences = (
  updatedPreferences: SettingsValues
): RestHandler =>
  rest.put(
    `${config.COMPLIANCE_API_URL}/${apiVersion}/settings/preferences/aml`,
    async (req, res, ctx) => {
      const payload = await req.json<UpdatePreferencesPayload>();

      if (!payload.searchType || !payload.sanctionBodies) {
        return res(
          ctx.status(HTTPS_ERROR),
          ctx.json({ message: "Missing required fields" })
        );
      }

      return res(ctx.status(HTTP_OK), ctx.json(updatedPreferences));
    }
  );
